import { FormArray, FormGroup } from '@angular/forms';

export function disableForm(form: FormGroup | FormArray): void {
    form.disable();

    for (const control of Object.values(form.controls)) {
        if (control instanceof FormGroup || control instanceof FormArray) {
            disableForm(control);
        } else {
            control.disable();
        }
    }
}

export function enableForm(form: FormGroup | FormArray): void {
    form.enable();

    for (const control of Object.values(form.controls)) {
        if (control instanceof FormGroup || control instanceof FormArray) {
            enableForm(control);
        } else {
            control.enable();
        }
    }
}
